(function(){


function initProductTabs(section){


  if(!section){
    return;
  }


  if(section.dataset.tabsInitialized === "true"){
    return;
  }


  section.dataset.tabsInitialized = "true";



  const tabs = section.querySelectorAll(
    ".saviour-product-tab"
  );


  const contents = section.querySelectorAll(
    ".saviour-product-tab-content"
  );



  tabs.forEach(function(tab){


    tab.addEventListener("click",function(){


      const target = tab.dataset.tab;



      tabs.forEach(function(item){

        item.classList.remove("active");

      });



      contents.forEach(function(content){

        content.classList.remove("active");

      });



      tab.classList.add("active");



      const targetContent = section.querySelector(
        "#" + target
      );



      if(targetContent){

        targetContent.classList.add("active");

      }


    });


  });


}





function initSizeGuide(section){


  if(!section){
    return;
  }



  if(section.dataset.sizeGuideInitialized === "true"){
    return;
  }


  section.dataset.sizeGuideInitialized = "true";



  const buttons = section.querySelectorAll(
    ".saviour-size-guide-button"
  );



  buttons.forEach(function(button){


    button.addEventListener(
      "click",
      function(){



        const item = button.closest(
          ".saviour-size-guide-item"
        );



        if(!item){
          return;
        }



        const panel = item.querySelector(
          ".saviour-size-guide-panel"
        );



        const icon = button.querySelector(
          "span:last-child"
        );



        const isOpen = item.classList.contains(
          "open"
        );



        item.classList.toggle(
          "open"
        );



        if(panel){

          panel.style.display = isOpen
            ? "none"
            : "block";

        }



        if(icon){

          icon.textContent = isOpen
            ? "+"
            : "−";

        }



      }
    );


  });


}





function initSaviourProductTabs(){


  document
  .querySelectorAll(
    ".saviour-product-tabs"
  )
  .forEach(function(section){


    initProductTabs(section);

    initSizeGuide(section);


  });


}




if(
document.readyState === "loading"
){


  document.addEventListener(
    "DOMContentLoaded",
    initSaviourProductTabs
  );


}else{


  initSaviourProductTabs();


}





document.addEventListener(
"shopify:section:load",
function(event){


  const section = event.target.querySelector(
    ".saviour-product-tabs"
  );



  if(section){

    initProductTabs(section);

    initSizeGuide(section);

  }



});


})();